import React, { Component } from 'react';
import './styles.scss';

type Props = {
  id: string;
  label: string;
  checked: boolean;
  onSelect: Function;
};
type State = {};

export default class Radio extends Component<Props, State> {
  render() {
    return (
      <div
        className={'sf-radio clickable' + (this.props.checked ? ' selected' : '')}
        style={{opacity:'inherit'}}
        onClick={() => {
          this.props.onSelect();
        }}>
        <input
          type='radio'
          id={this.props.id}
          checked={this.props.checked}
          onChange={() => {
            this.props.onSelect();
          }}
        />
        <label htmlFor={this.props.id} className='clickable' style={{opacity:1}}></label>
        {this.props.label}
      </div>
    );
  }
}
